import axios from '@tw/shared-ui-components/lib/utils/axios_interceptor';
import { getPdmApiUrl } from "../../../common/utils/helper";
import { getLoggedInUserInfo, getVisitorStatus } from "@tw/header-footer/lib/utils/helper";
import { MARKUP_PURCHASE } from "@tw/shared-ui-components/lib/utils/Constants/Constants"

import { ROLE_FOA } from "@tw/header-footer/lib/utils/constants";
const SET_PDP_STATE = "SET_PDP_STATE";
const SET_MARKUP_PURCHASE_STATE = "SET_MARKUP_PURCHASE_STATE";
const SET_REPORT_CHAT_BOT_DETAILS = "SET_REPORT_CHAT_BOT_DETAILS";

export const setPdpState = (state) => {
  return {
    type: SET_PDP_STATE,
    payload: state,
  };
};

export const setMarkupPurchaseState = (state) => {
  return {
    type: SET_MARKUP_PURCHASE_STATE,
    payload: state,
  };
};

export const setReportChatBotDetails = (state) => {
  return {
    type: SET_REPORT_CHAT_BOT_DETAILS,
    payload: state,
  };
};

export const fetchPdpState = (itemCode) => async (dispatch) => {
  try {
    const apiUrl = getPdmApiUrl();
    const res = await axios.post(
      `/pdp/${itemCode}`,
      {},
      {
        baseURL: apiUrl,
      }
    );
    dispatch(setPdpState(res.data));
  } catch (err) {
    console.log(err);
  }
};
//  获取加价购活动
export const fetchMarkupPurchaseState = (product) => async () => {
  try {
    if (product) {
      const apiUrl = getPdmApiUrl();
      const loggedInUserData = getLoggedInUserInfo();
      const isVisitor = getVisitorStatus();
      const params = {
        loginAda: isVisitor ? loggedInUserData?.vAda : loggedInUserData?.loginAda,
        loginMemberType: isVisitor ? ROLE_FOA : loggedInUserData?.role,
        loginType: isVisitor ? "V" : loggedInUserData?.loginType,
        businessVolume: product?.businessVolume,
        price: product?.price,
        pointValue: product?.pointValue,
        itemCode: product?.itemCode,
        API_TYPE: MARKUP_PURCHASE,
        quantity: product?.quantity
      }
      const res = await axios.post(`/anon/markup-purchase-activity`, params, { baseURL: apiUrl }
      );
      return res?.data ?? null
    }
  } catch (err) {
    console.log(err);
  }
};



const pdpState = (state = {}, action) => {
  switch (action.type) {
    case SET_PDP_STATE:
      return action.payload;
    default:
      return state;
  }
};
const markupPurchaseActivityState = (state = {}, action) => {
  switch (action.type) {
    case SET_MARKUP_PURCHASE_STATE:
      return action.payload;
    default:
      return state;
  }
};
const setChatBotDetails = (state = {}, action) => {
  switch (action.type) {
    case SET_REPORT_CHAT_BOT_DETAILS:
      return action.payload;
    default:
      return state;
  }
};

export default {
  pdpState,
  markupPurchaseActivityState,
  setChatBotDetails
};
